import React from "react";

// services
import { formatDate } from "../../utils/date-format";
import { formatPhone } from "../../utils/phone-format";

import DataNotFound from "../../atoms/DataNotFound";

import {
  IconAcordeon,
  CardsGrid,
  Card,
  Key,
  Code,
  Value,
  ControlAcordeon,
  AccordionShow,
  Acordeon,
} from "./styles";

function TableClientsTotal({ customers }) {
  return (
    <>
      {customers.length === 0 ? (
        <DataNotFound message="Nenhum resultado encontrado" />
      ) : (
        <CardsGrid>
          {customers.map((customer) => (
            <Card key={`active-${customer.id}`}>
              <Code>
                Código &nbsp;<Value>{customer.id}</Value>
              </Code>

              <AccordionShow type="checkbox" id={`active-${customer.id}`} />
              <ControlAcordeon htmlFor={`active-${customer.id}`}>
                <IconAcordeon />
              </ControlAcordeon>

              <Acordeon className="card">
                <Key>
                  Nome &nbsp;<Value>{customer.name}</Value>
                </Key>
                <Key>
                  Contato &nbsp;
                  <Value>
                    {customer.phone_number &&
                      formatPhone(customer.phone_number)}
                  </Value>
                </Key>
                <Key>
                  Data de criação &nbsp;
                  <Value>
                    {formatDate(customer.created_at, "dd-month-yyyy")}
                  </Value>
                </Key>
              </Acordeon>
            </Card>
          ))}
        </CardsGrid>
      )}
    </>
  );
}

export default TableClientsTotal;
